import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  CreateAudienceFromOfficeGroupFulfilledAction,
  LeaderAudiencesLoadFulfilledAction,
  UserNetworkLeadersListLoadFulfilledAction,
  UserNetworkLeadersListLoadMoreFulfilledAction,
} from '../../domains/leadersManagement/actions.types';
import { CreateAudienceFromDirectMembersFulfilledAction } from '../../domains/leadersManagement/createAudienceFromDirectMembersActions.types';
import { ThreadExtendedActivityTargetAudiencesAndNetworksLoadFulfilledAction } from '../../domains/threadExtendedActivityTargetAudiencesAndNetworks/actions.types';

import { Audiences } from './types';

export type AudienceAction =
  | LeaderAudiencesLoadFulfilledAction
  | CreateAudienceFromOfficeGroupFulfilledAction
  | CreateAudienceFromDirectMembersFulfilledAction
  | UserNetworkLeadersListLoadFulfilledAction
  | UserNetworkLeadersListLoadMoreFulfilledAction
  | ThreadExtendedActivityTargetAudiencesAndNetworksLoadFulfilledAction;

const initialState: Audiences = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<Audiences, AudienceAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'LEADER_AUDIENCES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'CREATE_AUDIENCE_FROM_OFFICE_GROUP.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'CREATE_AUDIENCE_FROM_DIRECT_MEMBERS.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'THREAD_EXTENDED_ACTIVITY_TARGET_AUDIENCES_AND_NETWORKS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    default:
      return state;
  }
};

export default reducer;
